"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _wizard = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/wizard.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _wizard.default);

function WizardNextStep(_ref) {
  var className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      label = _ref.label,
      onNext = _ref.onNext;
  var nextStepClasses = classnames("".concat(cssNamespace, "-wizard__next-step"), className);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: nextStepClasses
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    compact: true,
    onClick: onNext,
    option: "emphasized"
  }, label));
}

process.env.NODE_ENV !== "production" ? WizardNextStep.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Label to use on the next step button */
  label: _propTypes.default.string,

  /**
   * Callback function; triggered when the next step button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onNext: _propTypes.default.func
} : void 0;
WizardNextStep.defaultProps = {
  label: 'Next',
  onNext: function onNext() {}
};

var _default = (0, _withStyles.default)(WizardNextStep);

exports.default = _default;